export enum LanguageCode {
  EN = 'en',
  HU = 'hu',
  DE = 'de'
}
